import PropTypes from 'prop-types';

import Text from 'core/components/Text';
import Indent from 'core/components/Wrappers/Indent';

import Title from '../LegalPageTitle';

import styles from '../index.styl';


/**
 * @author Aminev Ramil <r.aminev@rambler-co.ru>
 */
export default function MailingRules({ title, content }) {
  return (
    <Text>
      <div className={styles.content}>
        <Title title={title} />
        {content}
      </div>
    </Text>
  );
}

MailingRules.defaultProps = {
  content: <>
    <Indent bottom={40} >
      <i>Условия рассылок определяют условия, на которых Компания предоставляет Сервис, позволяющий Пользователям получать Сообщения.</i>
    </Indent>
    <ol>
      <li>
        <h3 className={styles.subtitle}>Термины</h3>
        <ol>
          <li><b>Компания</b>&nbsp;&mdash; юридическое лицо, предоставляющее Пользователям Сервис. Наименование Компании размещено на&nbsp;Ресурсе.</li>
          <li><b>Сообщения</b>&nbsp;&mdash; информационные сообщения, в&nbsp;том числе новостного, рекламного или иного характера, связанные с&nbsp;Ресурсом и/или тематикой Ресурса, а&nbsp;также с&nbsp;товарами/услугами Компании и/или ее&nbsp;партнеров.</li>
          <li><b>Подписка на&nbsp;рассылку</b>&nbsp;&mdash; действия Пользователя при использовании Сервиса, направленные на&nbsp;систематическое получение Сообщений от&nbsp;Компании, в&nbsp;том числе внесение Пользователем контактных данных в&nbsp;соответствующую форму.</li>
        </ol>
      </li>
      <li>
        <h3 className={styles.subtitle}>Действие условий</h3>
        <ol>
          <li>Условия рассылок (Условия) являются частью Условий использования. Условия заключаются в&nbsp;соответствии с&nbsp;нормами законодательства&nbsp;РФ, регулирующими принятие публичной оферты конклюдентными действиями. Подписка на&nbsp;рассылку означает полный и&nbsp;безоговорочный акцепт Условий Пользователем. В&nbsp;случае несогласия Пользователя с&nbsp;каким-либо из&nbsp;положений Условий, Пользователь обязан воздержаться от&nbsp;Подписки на&nbsp;рассылку.</li>
          <li>Отношения Пользователя и&nbsp;Компании, возникающие в&nbsp;связи с&nbsp;Подпиской на&nbsp;рассылку, регулируются законодательством РФ.</li>
          <li>Условия могут быть изменены Компанией в&nbsp;одностороннем внесудебном порядке. Измененные Условия размещаются на&nbsp;Ресурсе. Продолжая получать Сообщения после изменения Условий, Пользователь принимает Условия полностью и&nbsp;безоговорочно в&nbsp;измененном виде.</li>
        </ol>
      </li>
      <li>
        <h3 className={styles.subtitle}>Условия рассылки сообщений</h3>
        <ol>
          <li>Принимая Условия, Пользователь дает согласие Компании на&nbsp;получение Сообщений от&nbsp;Компании по&nbsp;адресу электронной почты, указанному Пользователем при Подписке на&nbsp;рассылку. Пользователь осознает и&nbsp;соглашается, что Сообщения могут содержать рекламу. Пользователь вправе в&nbsp;любое время отказаться от&nbsp;получения Сообщений путем перехода по&nbsp;соответствующей гиперссылке, содержащейся в&nbsp;Сообщении.</li>
          <li>Для осуществления рассылки Компании необходима обработка адреса электронной почты Пользователя. Компания осуществляет указанную обработку в&nbsp;соответствии с&nbsp;Политикой конфиденциальности Компании.</li>
          <li>Принимая Условия, Пользователь дает согласие Компании на&nbsp;обработку (сбор, запись, систематизацию, накопление, хранение, уточнение, извлечение, использование, обезличивание, блокирование, удаление и&nbsp;уничтожение) предоставленных персональных данных для получения Пользователем сообщений и&nbsp;продвижения Ресурсов, продуктов и/или услуг Компании и&nbsp;ее&nbsp;партнеров. Данное согласие действует с&nbsp;момента предоставления данных Пользователем и&nbsp;до&nbsp;достижения цели их&nbsp;обработки и&nbsp;может быть отозвано путем направления Компании письменного заявления.</li>
          <li>Пользователь гарантирует Компании, что Подписка на&nbsp;рассылку осуществляется непосредственно Пользователем, а&nbsp;также, что адрес электронной почты, указанный Пользователем при Подписке на&nbsp;рассылку, является корректным и&nbsp;принадлежит Пользователю. Ответственность за&nbsp;правомерность предоставления данных при Подписке на&nbsp;рассылку и&nbsp;их&nbsp;достоверность несет исключительно Пользователь.</li>
        </ol>
      </li>
    </ol>
    <p className={styles.editorial}><i>Редакция от 6 декабря 2024</i></p>
  </>,
};
MailingRules.propTypes = {
  title: PropTypes.string,
  content: PropTypes.node,
};
